import api from './api';

export const validateUserLogin = async ({ token }) => api({ url: '/validate-user-login/', method: 'get', token });

export const loadPermissions = async () => api({ url: '/load-permissions/', method: 'get' });
